import React, { Component } from 'react';
import { Modal, Header, Button, FormUI as Forms, Grid, Icon, Dropdown, Segment } from 'semantic-ui-react'
import { Formik, Field, Form, select } from 'formik';
import ReadAxios from '../axiosComponent/readAxios';
import { UploadFile } from '../dynamicComponent/uploadFile';
import * as Yup from 'yup';
import MyCity from '../dynamicComponent/myCity';
import MyState from '../dynamicComponent/myState';
import CityNameComponent from '../customerComponent/cityNameComponent';
export default class BranchModal extends Component {

    state = {
        editing: false,
        rowitems: [],
        branches: [],
        gst_number: "GST",
        pan_number: "",
        file: '',
        isloading: ''
    }

    handleFile(e) {
        let document = e.target.files[0];
        this.setState({ file: document })
    }

    getData = () => {
        ReadAxios({
            masterURL: `${process.env.REACT_APP_MAIN_URL}/masters/stateMaster/`,
            method: "get"
        }).then((res) => {
            if (res.status === 200) {
                let states = res.data.resultSet.map((item, index) => {
                    return {
                        key: index + 1,
                        text: item.state,
                        value: item.stateId,
                        raw: { ...item },
                    };
                })
                // console.log("States : ", states)
                this.setState({
                    rowItems: states,
                    isLoaded: true
                })
            }
        })
    }

    getStates() {
        return this.state.rowItems.map((o, i) => {
            const { stateId, state } = o
            return (
                <option key={i} value={stateId} label={state} />
            )
        })
    }

    fetchStatesinfo = (data) => {
        console.log(data)
    }

    componentDidMount() {
        console.log("HELLO");
        this.getData()
    }
    viewPDF = (e, data) => {
        let path = `${process.env.REACT_APP_MAIN_URL}/vendor_onboarding/resource?customerNo=${localStorage.getItem('customerNo')}&resource_url=${data.pdf_value}`
        window.open(path, "_blank");
    }

    render() {
        let gst_format = '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$';
        let pan_format = '^[A-Z]{5}[0-9]{4}[A-Z]{1}$'
        let pincode_format = '^[1-9][0-9]{5}$'
        const { branchInfo, mode } = this.props
        let readon = (mode == "edit" ? '"true"' : '"false"')
        const ValidationSchema = Yup.object().shape({
            vendorBranchName: Yup.string()
                .min(2, 'Please enter a valid value')
                .max(50, 'Please enter a valid value')
                .required('Required'),
            vendorBranchStateId: Yup.number()
                .typeError('Please enter State ID')
                .min(1, 'Please enter a valid value')
                .max(50, 'Please enter a valid value')
                .required('Required'),
            vendorBranchGST: Yup.string()
                .matches(gst_format, 'Please enter a valid GST Number'),
            vendorBranchPAN: Yup.string()
                .matches(pan_format, 'Please enter a valid PAN Number')
                .required('Required'),
            // vendorBranchAddress: Yup.string()
            //     .min(2, 'Please enter a valid value')
            //     .max(50, 'Please enter a valid value')
            //     .nullable(),
            vendorBranchCity: Yup.string()
                .min(2, 'Please enter a valid value')
                .max(50, 'Please enter a valid value')
                .required('Required'),
            vendorBranchAccountNumber: Yup.string()
                .min(2, 'Please enter a valid value')
                .max(50, 'Please enter a valid value'),
            vendorBranchBankName: Yup.string()
                .min(2, 'Please enter a valid value')
                .max(50, 'Please enter a valid value'),
            vendorBranchBankAccountHolder: Yup.string()
                .min(1, 'Please enter a valid value')
                .max(50, 'Please enter a valid value'),
            vendorBranchBankIFSC: Yup.string()
                .min(2, 'Please enter a valid value')
                .max(50, 'Please enter a valid value'),
            vendorBranchBranchPincode: Yup.string()
                .matches(pincode_format, 'Please enter a valid PINCODE')
                .required('Required'),
            vendorBranchPANCardPath: Yup.mixed().required('Required'),
            vendorBranchCancelledChq: Yup.mixed().required('Required')
            // vendorBranchGSTCertPath: Yup.mixed().required('Required').test("fileSize", "The file is too large", (value) => {
            //     return value && value.fileList[0].size <= 5000000
            // }),
            // vendorBranchGSTExempPath: Yup.mixed().required('Required').test("fileSize", "The file is too large", (value) => {
            //     return value && value.fileList[0].size <= 5000000
            // }),
        });
        return (
            <div>
                <Modal
                    size="large"
                    /*eslint-disable*/
                    onClose={this.props.onClose}
                    open={this.props.open}
                >
                    <Header><h5>Add Branch Details</h5></Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Formik
                                initialValues={{
                                    vendorBranchName: this.props.mode == 'reg_edit' ? branchInfo.vendorBranchName : '',
                                    vendorBranchStateId: this.props.mode == 'reg_edit' ? branchInfo.vendorBranchStateId : '',
                                    vendorBranchGST: this.props.mode == 'reg_edit' ? branchInfo.vendorBranchGST : '',
                                    vendorBranchPAN: this.props.mode == 'reg_edit' ? branchInfo.vendorBranchPAN : '',
                                    vendorBranchAddress: this.props.mode == 'reg_edit' ? branchInfo.vendorBranchAddress : '',
                                    vendorBranchCity: this.props.mode == 'reg_edit' ? branchInfo.vendorBranchCity : '',
                                    vendorBranchBranchPincode: this.props.mode == 'reg_edit' ? branchInfo.vendorBranchBranchPincode : '',
                                    vendorBranchBankName: this.props.mode == 'reg_edit' ? branchInfo.vendorBranchBankName : '',
                                    vendorBranchBankAccountHolder: this.props.mode == 'reg_edit' ? branchInfo.vendorBranchBankAccountHolder : '',
                                    vendorBranchAccountNumber: this.props.mode == 'reg_edit' ? branchInfo.vendorBranchAccountNumber : '',
                                    vendorBranchBankIFSC: this.props.mode == 'reg_edit' ? branchInfo.vendorBranchBankIFSC : '',
                                    vendorBranchPANCardPath: this.props.mode == 'reg_edit' ? branchInfo.vendorBranchPANCardPath : '',
                                    vendorBranchCancelledChq: this.props.mode == 'reg_edit' ? branchInfo.vendorBranchCancelledChq : '',
                                    vendorBranchGSTCertPath: this.props.mode == 'reg_edit' ? branchInfo.vendorBranchGSTCertPath : '',
                                    vendorBranchGSTExempPath: this.props.mode == 'reg_edit' ? branchInfo.vendorBranchGSTExempPath : '',
                                    city_name: this.props.mode == 'reg_edit' ? branchInfo.city_name : '',
                                    state_name: this.props.mode == 'reg_edit' ? branchInfo.state_name : '',
                                }}
                                validationSchema={ValidationSchema}
                                onSubmit={(values) => {
                                    // console.log("FILE : ", values, branchInfo.id);
//check for mode, because of reg edit not able to save the data
                                    let panCard, cancelChq, gstCert, gstExmp, vendorBranchPANCardPath, vendorBranchCancelledChq, vendorBranchGSTCertPath, vendorBranchGSTExempPath;
                                    //put condition to check for fileupload changes change, for new upload object is returned
                                    if (this.props.mode == 'reg_edit') {
                                        if(typeof(values.vendorBranchPANCardPath)=='object'){
                                            panCard = values.vendorBranchPANCardPath ? values.vendorBranchPANCardPath.base64.split(',') : null
                                            vendorBranchPANCardPath = panCard ? panCard[1] : null
                                        }else{
                                            vendorBranchPANCardPath = values.vendorBranchPANCardPath
                                        }
                                        
                                        if(typeof(values.vendorBranchCancelledChq)=='object'){
                                            cancelChq = values.vendorBranchCancelledChq ? values.vendorBranchCancelledChq.base64.split(',') : null
                                            vendorBranchCancelledChq = cancelChq ? cancelChq[1] : null
                                        }else{
                                            vendorBranchCancelledChq = values.vendorBranchCancelledChq
                                        }
                                        
                                        if(typeof(values.vendorBranchCancelledChq)=='object'){
                                            gstCert = values.vendorBranchGSTCertPath ? values.vendorBranchGSTCertPath.base64.split(',') : null
                                            vendorBranchGSTCertPath = gstCert ? gstCert[1] : null
                                        }else{
                                            vendorBranchGSTCertPath = values.vendorBranchGSTCertPath
                                        }

                                        if(typeof(values.vendorBranchCancelledChq)=='object'){
                                            gstExmp = values.vendorBranchGSTExempPath ? values.vendorBranchGSTExempPath.base64.split(',') : null
                                            vendorBranchGSTExempPath = gstExmp ? gstExmp[1] : null
                                        }else{
                                            vendorBranchGSTExempPath = values.vendorBranchGSTExempPath
                                        }
                                    }else{
                                        panCard = values.vendorBranchPANCardPath || mode == 'reg_edit' ? values.vendorBranchPANCardPath.base64.split(',') : null
                                        cancelChq = values.vendorBranchCancelledChq || mode == 'reg_edit' ? values.vendorBranchCancelledChq.base64.split(',') : null
                                        gstCert = values.vendorBranchGSTCertPath || mode == 'reg_edit' ? values.vendorBranchGSTCertPath.base64.split(',') : null
                                        gstExmp = values.vendorBranchGSTExempPath || mode == 'reg_edit' ? values.vendorBranchGSTExempPath.base64.split(',') : null
                                        vendorBranchPANCardPath = panCard ? panCard[1] : null
                                        vendorBranchCancelledChq = cancelChq ? cancelChq[1] : null
                                        vendorBranchGSTCertPath = gstCert ? gstCert[1] : null
                                        vendorBranchGSTExempPath = gstExmp ? gstExmp[1] : null
                                    }
                                                                    
                                    
                                    let id = branchInfo.id
                                    let combineParams = {
                                        ...values, vendorBranchPANCardPath, vendorBranchCancelledChq, vendorBranchGSTCertPath,
                                        vendorBranchGSTExempPath, id
                                    }
                                    let data = (JSON.stringify(combineParams, null, 2));
                                    let branches = []
                                    branches = JSON.parse(data)
                                    if (this.props.mode == 'reg_edit') {
                                        this.props.getEditbranchdata(branches)
                                    }
                                    else {
                                        this.props.getbranchdata(branches)
                                    }
                                }}
                            >

                                {({ values, errors, touched, setFieldValue, handleChange, handleBlur, handleReset }) => (
                                    <Form >
                                        <Segment className="m-2">
                                            <Grid.Row>
                                                <div className="col-6">
                                                    <label className="tiny ui form form-label">Branch Name *</label>
                                                    <Field readOnly={mode == "edit" ? true : false} className="field-class" name="vendorBranchName" />
                                                    {
                                                    errors.vendorBranchName && touched.vendorBranchName ? (
                                                        <div className="p-10 w3-text-red">{errors.vendorBranchName}</div>
                                                    ) : null
                                                    }

                                                    <br />
                                                    {console.log('>VALUES', values)}
                                                    <label className="tiny ui form form-label mt-3">GST Number</label>
                                                    <Field readOnly={mode == "edit" ? true : false} className="mt-3 field-class" id="vendorBranchGST" name="vendorBranchGST" maxLength={[15, 'Invalid GST number']}
                                                        onMouseOut={(name, data) =>
                                                            setFieldValue("vendorBranchPAN", vendorBranchGST.value.substring(2, 12))
                                                        }
                                                    />
                                                    {errors.vendorBranchGST && touched.vendorBranchGST ? <div className="p-10 w3-text-red">{errors.vendorBranchGST}</div> : null}

                                                    <br />

                                                    <div class="form-inline">
                                                        <div class="form-group ">
                                                            <label className="tiny ui form textarea-label mt-3" >Address</label>
                                                            <Field readOnly={mode == "edit" ? true : false} className="mt-3 textarea-class" as="textarea" id="address" name="vendorBranchAddress" />
                                                            {errors.vendorBranchAddress && touched.vendorBranchAddress ? <div className="p-10 w3-text-red">{errors.vendorBranchAddress}</div> : null}

                                                        </div>
                                                    </div>

                                                    <br />

                                                    <label className="tiny ui form form-label mt-3">Bank Name</label>
                                                    <Field readOnly={mode == "edit" ? true : false} className="mt-3 field-class" id="vendorBranchBankName" name="vendorBranchBankName" />
                                                    {errors.vendorBranchBankName && touched.vendorBranchBankName ? <div className="p-10 w3-text-red">{errors.vendorBranchBankName}</div> : null}

                                                    <br />

                                                    <label className="tiny ui form form-label mt-3">Account Number</label>
                                                    <Field readOnly={mode == "edit" ? true : false} className="mt-3 field-class" id="address" name="vendorBranchAccountNumber" />
                                                    {errors.vendorBranchAccountNumber && touched.vendorBranchAccountNumber ? <div className="p-10 w3-text-red">{errors.vendorBranchAccountNumber}</div> : null}

                                                    <br />

                                                    <label className="tiny ui form form-label mt-3">Pincode *</label>
                                                    <Field readOnly={mode == "edit" ? true : false} className="mt-3 field-class" id="vendorBranchBranchPincode" name="vendorBranchBranchPincode" maxLength={[6, 'Pincode cannot be longer than 6 digits']} />
                                                    {errors.vendorBranchBranchPincode && touched.vendorBranchBranchPincode ? <div className="p-10 w3-text-red">{errors.vendorBranchBranchPincode}</div> : null}

                                                    <br />
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <label className="tiny ui form form-label mt-3">PAN Card</label>
                                                            {errors.vendorBranchPANCardPath && touched.vendorBranchPANCardPath ? <div className="p-10 w3-text-red">{errors.vendorBranchPANCardPath}</div> : null}

                                                        </div>
                                                        <div className="col-6 mt-2">
                                                            {mode === 'edit' ? <Button type="button" size="mini" disabled={values.vendorBranchPANCardPath ? false : true} onClick={this.viewPDF} pdf_value={values.vendorBranchPANCardPath} color="facebook" icon><Icon name="download" /> PDF</Button> :
                                                                <>
                                                                    <Field component={UploadFile} typer={[".pdf"]} clrd="blue" classNameBtn="mt-2" buttonName={values.vendorBranchPANCardPath ? <> PDF <Icon color="green" name="check" /> </> : "PDF"} id="vendorBranchPANCardPath" name="vendorBranchPANCardPath" />
                                                                </>}
                                                        </div>
                                                    </div>
                                                    <br />
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <label className="tiny ui form form-label mt-3">Cancelled Cheque</label>
                                                            {errors.vendorBranchCancelledChq && touched.vendorBranchCancelledChq ? <div className="p-10 w3-text-red">{errors.vendorBranchCancelledChq}</div> : null}
                                                        </div>
                                                        <div className="col-6 mt-2">
                                                            {mode === 'edit' ? <Button type="button" size="mini" disabled={values.vendorBranchCancelledChq ? false : true} onClick={this.viewPDF} pdf_value={values.vendorBranchCancelledChq} color="facebook" icon><Icon name="download" /> PDF</Button> :
                                                                <>
                                                                    <Field component={UploadFile} typer={[".pdf"]} clrd="blue" classNameBtn="mt-2" buttonName={values.vendorBranchCancelledChq ? <> PDF <Icon color="green" name="check" /> </> : "PDF"} id="vendorBranchCancelledChq" name="vendorBranchCancelledChq" />
                                                                </>}
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* {console.log('>>>', values.vendorBranchStateId)} */}
                                                <div className="col-6">
                                                    <label className="tiny ui form form-label" style={{ marginTop: "-20px" }}>State *</label>

                                                    <>
                                                        <Field readOnly={mode == "edit" ? true : false} value={values.vendorBranchStateId} disabled={mode == "edit" ? true : false} component={MyState} getStateInfo={(data) => {
                                                            setFieldValue('state_name', data.state)
                                                        }} style={{ width: "50%", fontWeight: "normal" }} className="field-class" id="city" name="vendorBranchStateId" />
                                                        {errors.vendorBranchStateId && touched.vendorBranchStateId ? (
                                                            <div className="p-10 w3-text-red">{errors.vendorBranchStateId}</div>
                                                        ) : null}
                                                    </>

                                                    {/* <Dropdown
                                                        clearable
                                                        style={{ width: "50%", fontWeight: "normal" }}
                                                        search
                                                        name="vendorBranchStateId"
                                                        selection
                                                        placeholder={
                                                            "Select State"
                                                        }
                                                        onChange={(name, data) =>
                                                            setFieldValue("vendorBranchStateId", data.value)
                                                        }
                                                        options={this.state.rowItems}
                                                    /> */}

                                                    <br />

                                                    <label className="tiny ui form form-label mt-3">PAN Number</label>
                                                    <Field readOnly={mode == "edit" ? true : false} className="mt-3 field-class" id="pan" name="vendorBranchPAN" />
                                                    {errors.vendorBranchPAN && touched.vendorBranchPAN ? (
                                                        <div className="p-10 w3-text-red">{errors.vendorBranchPAN}</div>
                                                    ) : null}

                                                    <br />
                                                    <label className="tiny ui form form-label">City *</label>

                                                    {mode === 'edit' ?
                                                        <CityNameComponent
                                                            cityId={values.vendorBranchCity}
                                                            type={"addBranchType"}
                                                        />
                                                        // <Field readOnly={mode == "edit" ? true : false} className="mt-3 textarea-class" id="city" name="vendorBranchCity" />
                                                        :
                                                        <>
                                                            <Field readOnly={mode == "edit" ? true : false} value={values.vendorBranchCity} component={MyCity} getCityInfo={(data) => {
                                                                setFieldValue('city_name', data.cityName)
                                                                // console.log(data)
                                                            }} style={{ width: "50%", fontWeight: "normal" }} className="mt-3 field-class" id="city" name="vendorBranchCity" />
                                                            {errors.vendorBranchCity && touched.vendorBranchCity ? <div className="p-10 w3-text-red">{errors.vendorBranchCity}</div> : null}
                                                        </>
                                                    }
                                                    <br />

                                                    <label className="tiny ui form form-label mt-3">Account Holder Name</label>
                                                    <Field readOnly={mode == "edit" ? true : false} className="mt-3 field-class" id="vendorBranchBankAccountHolder" name="vendorBranchBankAccountHolder" />
                                                    {errors.vendorBranchBankAccountHolder && touched.vendorBranchBankAccountHolder ? <div className="p-10 w3-text-red">{errors.vendorBranchBankAccountHolder}</div> : null}

                                                    <br />

                                                    <label className="tiny ui form form-label mt-3">IFSC Code</label>
                                                    <Field readOnly={mode == "edit" ? true : false} className="mt-3 field-class" id="vendorBranchBankIFSC" name="vendorBranchBankIFSC" />
                                                    {errors.vendorBranchBankIFSC && touched.vendorBranchBankIFSC ? <div className="p-10 w3-text-red">{errors.vendorBranchBankIFSC}</div> : null}

                                                    <br />
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <label className="tiny ui form form-label mt-3">GST Certificate</label>
                                                        </div>
                                                        <div className="col-6 mt-2">
                                                            {mode === 'edit' ? <Button type="button" disabled={values.vendorBranchGSTCertPath ? false : true} size="mini" onClick={this.viewPDF} pdf_value={values.vendorBranchGSTCertPath} color="facebook" icon><Icon name="download" /> PDF</Button> :
                                                                <>
                                                                    <Field component={UploadFile} typer={[".pdf"]} clrd="blue" classNameBtn="mt-2" buttonName={values.vendorBranchGSTCertPath ? <> PDF <Icon color="green" name="check" /> </> : "PDF"} id="vendorBranchGSTCertPath" name="vendorBranchGSTCertPath" />
                                                                    {errors.vendorBranchGSTCertPath && touched.vendorBranchGSTCertPath ? <div className="p-10 w3-text-red">{errors.vendorBranchGSTCertPath}</div> : null}
                                                                </>
                                                            }
                                                        </div>
                                                    </div>


                                                    <br />
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <label className="tiny ui form form-label mt-3">GST Excemption Certificate</label>
                                                        </div>
                                                        <div className="col-6">
                                                            {mode === 'edit' ? <Button type="button" size="mini" disabled={values.vendorBranchGSTExempPath ? false : true} onClick={this.viewPDF} pdf_value={values.vendorBranchGSTExempPath} disable={values.vendorBranchGSTExempPath != null ? false : true} color="facebook" icon><Icon name="download" /> PDF</Button> :
                                                                <>
                                                                    <Field component={UploadFile} typer={[".pdf"]} clrd="blue" classNameBtn="mt-2" buttonName={values.vendorBranchGSTExempPath ? <> PDF <Icon color="green" name="check" /> </> : "PDF"} id="vendorBranchGSTExempPath" name="vendorBranchGSTExempPath" />
                                                                    {errors.vendorBranchGSTExempPath && touched.vendorBranchGSTExempPath ? <div className="p-10 w3-text-red">{errors.vendorBranchGSTExempPath}</div> : null}
                                                                </>}
                                                        </div>
                                                    </div>

                                                </div>
                                            </Grid.Row>
                                        </Segment>
                                        <center>
                                            {mode === 'edit' ? '' : <Button type="submit" className="m-2 mt-3" primary size="mini">Save</Button>}
                                            <Button type="button" className="m-2 mt-3" onClick={this.props.handleClose} size="mini">Cancel</Button>
                                        </center>
                                    </Form>
                                )}
                            </Formik>
                        </Modal.Description>
                    </Modal.Content>
                </Modal>
            </div>
        );

    }
}